module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Zm9ybS1pY29uL2lucHV0LWVycm9yPC90aXRsZT48cGF0aCBkPSJNNyAxQzMuNyAxIDEgMy43IDEgN3MyLjcgNiA2IDYgNi0yLjcgNi02LTIuNy02LTYtNnptMCAxMGMtLjYgMC0xLS40LTEtMXMuNC0xIDEtMSAxIC40IDEgMS0uNCAxLTEgMXptMS0zSDZWNGgydjR6IiBmaWxsPSIjRkZCQjI5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/service-ticket/error.svg
// module id = KSt/
// module chunks = 17